import { T } from 'consts/translationKeys'

export const FILTER_DROPDOWNS = [
  {
    key: 'duration',
    labelKey: T.DURATION_LABEL,
    className: 'duration-dropdown'
  },
  {
    key: 'aspectRatio',
    labelKey: T.ASPECT_RATIO_LABEL,
    className: 'option-dropdown'
  },
  {
    key: 'quality',
    labelKey: T.QUALITY_LABEL,
    className: 'quality-dropdown'
  }
] as const
